(function() {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function markDropLive(root, dropAt) {
    if (!root || root.dataset.gmDropLive === 'true') return;
    root.dataset.gmDropLive = 'true';

    var units = root.querySelector('[data-countdown-units]');
    var live = root.querySelector('[data-countdown-live]');
    if (units) units.hidden = true;
    if (live) live.hidden = false;
    root.classList.add('is-live');

    var drop = root.closest('[data-gm-drop]');
    if (drop) {
      drop.classList.add('is-live');
      var label = drop.querySelector('[data-countdown-label]');
      if (label) label.hidden = true;
    }

    window.dispatchEvent(new CustomEvent('gm-drop-live', {
      detail: { root: root, dropAt: dropAt }
    }));
  }

  function initCountdown(root) {
    if (!root || root.dataset.gmCountdownReady === 'true') return;
    root.dataset.gmCountdownReady = 'true';

    var dropAt = root.getAttribute('data-drop-at');
    if (!dropAt) return;

    var target = new Date(dropAt);
    if (isNaN(target.getTime())) return;

    var daysEl = root.querySelector('[data-countdown-days]');
    var hoursEl = root.querySelector('[data-countdown-hours]');
    var minutesEl = root.querySelector('[data-countdown-minutes]');
    if (!daysEl || !hoursEl || !minutesEl) return;

    function tick() {
      var now = Date.now();
      var diff = Math.max(0, target.getTime() - now);
      var totalMinutes = Math.floor(diff / 60000);
      var days = Math.floor(totalMinutes / (60 * 24));
      var hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      var minutes = totalMinutes % 60;
      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      if (diff <= 0) markDropLive(root, dropAt);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-gm-countdown]').forEach(initCountdown);
  }

  window.__gmCountdown = { initAll: initAll };

  document.addEventListener('DOMContentLoaded', initAll);
})();
